export default "/fonts/fa-regular-400.woff2?1f3772178d9e5bed38a6ca738d28cd4b";